import { render, staticRenderFns } from "./RoomEvent.vue?vue&type=template&id=6ab42576&scoped=true&"
import script from "./RoomEvent.vue?vue&type=script&lang=js&"
export * from "./RoomEvent.vue?vue&type=script&lang=js&"
import style0 from "./RoomEvent.vue?vue&type=style&index=0&id=6ab42576&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab42576",
  null
  
)

component.options.__file = "RoomEvent.vue"
export default component.exports